export default setting => window.start.settings?.[setting];
